import { ITreeFile, ITreeFolder, ITreeObject } from '@/codeGeneration/codeGen';
import { Octokit } from '@octokit/core';
import { getUserDetails } from './gitAuth';
import { getFilePath } from '@/codeGeneration/codeGen';
import { getBranchDetails } from './gitBranch';
// https://dev.to/bro3886/create-a-folder-and-push-multiple-files-under-a-single-commit-through-github-api-23kc

interface GitTreeFile {
  path: string;
  mode: string;
  type: string;
  sha?: string;
}
interface GitTree {
  sha: string;
  url: string;
  tree: GitTreeFile[];
  truncated: boolean;
}
export const gitCommit = async (
  token: string,
  fileTree: ITreeFolder,
  repoName: string,
  message: string,
  branch: string
) => {
  const userDetails = await getUserDetails(token);
  const fileList = getFileListFromTree(fileTree);
  let gitFileList: GitTreeFile[] = [];
  // getting blobs for file
  for (const file of fileList) {
    const gitObject = await treeObjectToGitObject(
      file,
      token,
      repoName,
      userDetails.login,
      fileTree
    );
    if (gitObject) gitFileList.push(gitObject);
  }
  const branchDetails = await getBranchDetails(
    token,
    userDetails.login,
    repoName,
    branch
  );
  const newTree = await createTree(
    token,
    userDetails.login,
    repoName,
    branchDetails.commit.sha,
    gitFileList
  );
  const commitRes = await commitTree(
    token,
    userDetails.login,
    repoName,
    message,
    newTree,
    branchDetails.commit.sha
  );
  const referenceRes = await pushReference(
    token,
    userDetails.login,
    repoName,
    branch,
    commitRes.sha
  );
  return referenceRes;
};
const commitTree = async (
  token: string,
  owner: string,
  repoName: string,
  message: string,
  tree: GitTree,
  prevCommit: string
) => {
  const octokit = new Octokit({ auth: token });
  const commitRes = await octokit.request(
    `POST /repos/${owner}/${repoName}/git/commits`,
    { tree: tree.sha, message: message, parents: [prevCommit] }
  );
  return commitRes.data;
};
const pushReference = async (
  token: string,
  owner: string,
  repoName: string,
  branch: string,
  sha: string
) => {
  const octokit = new Octokit({
    auth: token
  });
  // try {
  //   const res = await octokit.request(
  //     `POST /repos/${owner}/${repoName}/git/refs`,
  //     {
  //       owner: owner,
  //       repo: repoName,
  //       ref: `refs/heads/${branch}`,
  //       sha: sha,
  //       headers: {
  //         'X-GitHub-Api-Version': '2022-11-28'
  //       }
  //     }
  //   );
  //   return res.data;
  // } catch (e) {
  // console.log(e);
  const res = await octokit.request(
    `PATCH /repos/${owner}/${repoName}/git/refs/heads/${branch}`,
    {
      // force: true,
      sha: sha,
      headers: {
        'X-GitHub-Api-Version': '2022-11-28'
      }
    }
  );
  return res.data;
  // }
};

const createTree = async (
  token: string,
  owner: string,
  repoName: string,
  baseTree: string,
  fileList: GitTreeFile[]
): Promise<GitTree> => {
  const octokit = new Octokit({ auth: token });
  const res = await octokit.request(
    `POST /repos/${owner}/${repoName}/git/trees`,
    {
      tree: fileList,
      base_tree: baseTree,
      headers: {
        'X-GitHub-Api-Version': '2022-11-28'
      }
    }
  );
  return res.data;
};

const getFileBlob = async (
  token: string,
  repoName: string,
  owner: string,
  file: ITreeFile
): Promise<{ url: string; sha: string }> => {
  const octokit = new Octokit({ auth: token });
  const res = await octokit.request(
    `POST /repos/${owner}/${repoName}/git/blobs`,
    {
      owner: owner,
      repo: repoName,
      content: file.data,
      encoding: 'utf-8',
      headers: {
        'X-GitHub-Api-Version': '2022-11-28'
      }
    }
  );
  return res.data;
};

const getFileListFromTree = (fileTree: ITreeFolder): ITreeFile[] => {
  let fileList: ITreeFile[] = [];
  for (let child of fileTree.children) {
    const childFile = child as ITreeFile;
    const childDir = child as ITreeFolder;
    if (childFile.data) {
      fileList.push(childFile);
    } else if (childDir.children) {
      fileList = fileList.concat(getFileListFromTree(childDir));
    }
  }
  return fileList;
};

const getListFromTree = (fileTree: ITreeFolder): ITreeObject[] => {
  let fileList: ITreeObject[] = [];
  for (let child of fileTree.children) {
    const childDir = child as ITreeFolder;
    fileList.push(child);
    if (childDir.children) {
      fileList = fileList.concat(getFileListFromTree(childDir));
    }
  }
  return fileList;
};

const treeObjectToGitObject = async (
  treeObject: ITreeObject,
  token: string,
  repoName: string,
  owner: string,
  fileTree: ITreeObject
): Promise<GitTreeFile | undefined> => {
  const dirObject = treeObject as ITreeFolder;
  const file = treeObject as ITreeFile;
  const filePath = getFilePath(fileTree, treeObject);
  if (!filePath) return;
  if (file.data) {
    const fileBlob = await getFileBlob(token, repoName, owner, file);
    if (!fileBlob || !fileBlob.sha) return;
    return {
      path: filePath,
      mode: '100644',
      type: 'blob',
      sha: fileBlob.sha
    };
  } else if (dirObject.children) {
    return {
      path: filePath,
      mode: '040000',
      type: 'tree'
    };
  }
  return undefined;
};
